import React, { ReactNode } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import AppState from "../model/AppState";

type ModalMaioridadeProps = {
  children?: ReactNode,
  visivel: boolean,
  save: any,
};

type ModalMaioridadeState = {
};

class ModalMaioridade extends React.Component<ModalMaioridadeProps, ModalMaioridadeState> {

  constructor(props: ModalMaioridadeProps) {
    super(props);

    this.saveMaioridade = this.saveMaioridade.bind(this);
    this.saveParent = this.saveParent.bind(this);
    this.saveNaoMaioridade = this.saveNaoMaioridade.bind(this);

  }

  saveMaioridade(): void {
    AppState.setMaioridade(true);
    this.saveParent();
  }

  saveNaoMaioridade(): void {
    AppState.setMaioridade(false);
    this.saveParent();
  }

  saveParent(): void {
    const { save } = this.props;
    if (save) {
      save();
    }
  }

  render(): any {
    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal maioridade" id="subs-modal">
            <p className="title">Você é maior de 18 anos?</p>
            <div className="menu">
              <button onClick={ this.saveMaioridade } className="confirmar">Sim, sou maior de 18 anos</button>
              <button onClick={ this.saveNaoMaioridade }>Sou menor de idade</button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalMaioridade;